import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, of, switchMap } from 'rxjs';
import { materialTypesActions } from '../actions/material-types.actions';
import { HttpService } from '../services/http.service';

@Injectable()
export class MaterialTypesEffects {
    private readonly actions = inject(Actions);
    private readonly httpService = inject(HttpService);

    getMaterialTypes$ = createEffect(() => {
        return this.actions.pipe(
            ofType(materialTypesActions.getMaterialTypes),
            switchMap(() => {
                return this.httpService.getMaterialTypes().pipe(
                    map((payload) => materialTypesActions.getMaterialTypesSuccess({ payload })),
                    catchError((error: HttpErrorResponse) => of(materialTypesActions.getMaterialTypesError({ code: error.status }))),
                );
            }),
        );
    });

    getMaterials$ = createEffect(() => {
        return this.actions.pipe(
            ofType(materialTypesActions.getMaterials),
            switchMap(({ id }) => {
                return this.httpService.getMaterials(id).pipe(
                    map((payload) => materialTypesActions.getMaterialsSuccess({ payload })),
                    catchError((error: HttpErrorResponse) => of(materialTypesActions.getMaterialsError({ code: error.status }))),
                );
            }),
        );
    });
}
